import React from 'react';
import styled from 'styled-components';
import { OutlinedButton } from '@prisjakt/ui/button/variants';
import { CdnImage } from 'src/components/cdn-image';
import { defaultTheme, layout, media } from 'src/components/base';

// TODO Add equivalent icon to DS and use here
// Visible here: http://dev.prisjakt.nu:3000/search?search=badboll
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';

import { Store } from '../types';

const ICON_SIZE = 15;

type Props = {
  className?: string;
  href: string | null;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  store?: Store | null;
  featured: boolean | undefined | null;
  containerProps?: {};
};

export const ClickOutButton: React.FC<Props> = props => {
  const {
    className,
    href,
    disabled = false,
    onClick,
    store,
    featured,
    containerProps,
  } = props;

  const renderButtonContent = () => {
    if (!store) {
      return null;
    }

    if (featured) {
      return (
        <CdnImage
          name={(store && store.id) || ''}
          alt={(store && store.name) || ''}
        />
      );
    }

    return store.name;
  };

  const renderClickOutIcon = () => {
    if (!featured) {
      return null;
    }

    return (
      <IconWrapper>
        <OpenInNewIcon color={defaultTheme.colors.base400} size={ICON_SIZE} />
      </IconWrapper>
    );
  };

  return (
    <OuterWrapper>
      <OutlinedButton
        className={className}
        containerProps={{
          ...containerProps,
          ...(href && {
            href: href || '',
            rel: 'nofollow',
            target: '_blank',
          }),
        }}
        container={href ? 'a' : undefined}
        disabled={disabled}
        onClick={onClick}
        fullWidth
      >
        <InnerWrapper>
          <StoreInfo image={(store && featured) || false}>
            {renderButtonContent()}
          </StoreInfo>
          {renderClickOutIcon()}
        </InnerWrapper>
      </OutlinedButton>
    </OuterWrapper>
  );
};

const IconWrapper = styled.div`
  margin-left: ${layout.measurements.spacing025};
  & > * {
    vertical-align: middle;
  }
`;

const OuterWrapper = styled.div`
  height: 74px;
  display: flex;
  justify-content: center;
  padding: ${layout.measurements.spacing100};
  width: 100%;
`;

const StoreInfo = styled.div<{ image: boolean }>`
  flex: 1 0 auto;
  text-align: center;
  overflow: hidden;
  ${p => (!p.image ? 'padding: 1px 0;' : '')}
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - (${ICON_SIZE}px + ${layout.measurements.spacing025}));
`;

const InnerWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  ${media.smallOnly`
    justify-content: center;
  `}
`;
